export default "__VITE_ASSET__CBbl9Rv5__"